import axios, { AxiosInstance } from 'axios';
import axiosInstance from '../utilities/axios-instance';

export interface TileJson {
  bounds: [number, number, number, number];
  description: string;
  format: string;
  map: string;
  maxzoom: number;
  minzoom: number;
  name: string;
  scheme: string;
  tilejson: string;
  tiles: string[];
  tilesize: number;
  type: string;
  version: string;
}

class TilesClient {
  private instance: AxiosInstance;
  private baseUrl = '';

  constructor(instance?: AxiosInstance) {
    this.instance = instance ?? axios.create();
  }

  setBaseUrl(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async getTileJson(floorId: string) {
    return this.instance.get<TileJson>(`${this.baseUrl}/${floorId}`);
  }
}
const tilesClient = new TilesClient(axiosInstance as any);

export default tilesClient;
